// @flow
import React from 'react';
import i18n from 'i18n-js';

import { FullLoader } from '../../Loader';
import styles from './studentScheduleLoader.css';
import { Loading } from '../../CommonTexts';


const StudentScheduleLoader = () => (
  <tr>
    <td className={styles.studentScheduleLoader} colSpan={9}>
      <FullLoader
        tint="mediumGray"
        title={Loading(i18n.t('common.calendarization'))}
      />
    </td>
  </tr>
);


export default StudentScheduleLoader;



// WEBPACK FOOTER //
// ./src/scripts/components/StudentSchedulingPopup/StudentScheduleLoader/index.jsx